import axios from "../axios";

const getLoginLogs = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('/log-activity/getLoginLogs', params ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getLoginLogs;
